<span
    [innerHtml]="
        commentString | newLine | linky: { urls: { tldMatches: false } } | safeHtml | replaceEmojis: true
    "></span>
